import { render, staticRenderFns } from "./itemInfo.vue?vue&type=template&id=83958d24&scoped=true"
import script from "./itemInfo.vue?vue&type=script&lang=js"
export * from "./itemInfo.vue?vue&type=script&lang=js"
import style0 from "./itemInfo.vue?vue&type=style&index=0&id=83958d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83958d24",
  null
  
)

export default component.exports